import _classCallCheck from "/home/runner/work/soroban-rpc-api/soroban-rpc-api/build/docs/gatsby/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/runner/work/soroban-rpc-api/soroban-rpc-api/build/docs/gatsby/node_modules/@babel/runtime/helpers/esm/createClass";
import _get from "/home/runner/work/soroban-rpc-api/soroban-rpc-api/build/docs/gatsby/node_modules/@babel/runtime/helpers/esm/get";
import _inherits from "/home/runner/work/soroban-rpc-api/soroban-rpc-api/build/docs/gatsby/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/home/runner/work/soroban-rpc-api/soroban-rpc-api/build/docs/gatsby/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/home/runner/work/soroban-rpc-api/soroban-rpc-api/build/docs/gatsby/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import "core-js/modules/esnext.string.replace-all.js";
import _regeneratorRuntime from "/home/runner/work/soroban-rpc-api/soroban-rpc-api/build/docs/gatsby/node_modules/@babel/runtime/regenerator";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/
var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
      r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
      d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
    if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  }
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};

var __param = this && this.__param || function (paramIndex, decorator) {
  return function (target, key) {
    decorator(target, key, paramIndex);
  };
};

var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }

  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }

    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }

    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }

    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};

import * as nls from '../../../nls.js';
import { Delayer } from '../../../base/common/async.js';
import { Disposable } from '../../../base/common/lifecycle.js';
import * as strings from '../../../base/common/strings.js';
import { EditorAction, EditorCommand, registerEditorAction, registerEditorCommand, registerEditorContribution, MultiEditorAction, registerMultiEditorAction } from '../../browser/editorExtensions.js';
import { EditorContextKeys } from '../../common/editorContextKeys.js';
import { CONTEXT_FIND_INPUT_FOCUSED, CONTEXT_FIND_WIDGET_VISIBLE, FIND_IDS, FindModelBoundToEditorModel, ToggleCaseSensitiveKeybinding, ToggleRegexKeybinding, ToggleSearchScopeKeybinding, ToggleWholeWordKeybinding, CONTEXT_REPLACE_INPUT_FOCUSED } from './findModel.js';
import { FindOptionsWidget } from './findOptionsWidget.js';
import { FindReplaceState } from './findState.js';
import { FindWidget } from './findWidget.js';
import { MenuId } from '../../../platform/actions/common/actions.js';
import { IClipboardService } from '../../../platform/clipboard/common/clipboardService.js';
import { IContextKeyService, ContextKeyExpr } from '../../../platform/contextkey/common/contextkey.js';
import { IContextViewService } from '../../../platform/contextview/browser/contextView.js';
import { IKeybindingService } from '../../../platform/keybinding/common/keybinding.js';
import { IStorageService } from '../../../platform/storage/common/storage.js';
import { IThemeService } from '../../../platform/theme/common/themeService.js';
import { INotificationService } from '../../../platform/notification/common/notification.js';
import { IStorageKeysSyncRegistryService } from '../../../platform/userDataSync/common/storageKeys.js';
var SEARCH_STRING_MAX_LENGTH = 524288;
export function getSelectionSearchString(editor) {
  if (!editor.hasModel()) {
    return null;
  }

  var selection = editor.getSelection(); // if selection spans multiple lines, default search string to empty

  if (selection.startLineNumber === selection.endLineNumber) {
    if (selection.isEmpty()) {
      var wordAtPosition = editor.getConfiguredWordAtPosition(selection.getStartPosition());

      if (wordAtPosition) {
        return wordAtPosition.word;
      }
    } else {
      if (editor.getModel().getValueLengthInRange(selection) < SEARCH_STRING_MAX_LENGTH) {
        return editor.getModel().getValueInRange(selection);
      }
    }
  }

  return null;
}

var CommonFindController = /*#__PURE__*/function (_Disposable) {
  _inherits(CommonFindController, _Disposable);

  var _super2 = _createSuper(CommonFindController);

  function CommonFindController(editor, contextKeyService, storageService, clipboardService) {
    var _this;

    _classCallCheck(this, CommonFindController);

    _this = _super2.call(this);
    _this._editor = editor;
    _this._findWidgetVisible = CONTEXT_FIND_WIDGET_VISIBLE.bindTo(contextKeyService);
    _this._contextKeyService = contextKeyService;
    _this._storageService = storageService;
    _this._clipboardService = clipboardService;
    _this._updateHistoryDelayer = new Delayer(500);
    _this._state = _this._register(new FindReplaceState());

    _this.loadQueryState();

    _this._register(_this._state.onFindReplaceStateChange(function (e) {
      return _this._onStateChanged(e);
    }));

    _this._model = null;

    _this._register(_this._editor.onDidChangeModel(function () {
      var shouldRestartFind = _this._editor.getModel() && _this._state.isRevealed;

      _this.disposeModel();

      _this._state.change({
        searchScope: null,
        matchCase: _this._storageService.getBoolean('editor.matchCase', 1
        /* WORKSPACE */
        , false),
        wholeWord: _this._storageService.getBoolean('editor.wholeWord', 1
        /* WORKSPACE */
        , false),
        isRegex: _this._storageService.getBoolean('editor.isRegex', 1
        /* WORKSPACE */
        , false),
        preserveCase: _this._storageService.getBoolean('editor.preserveCase', 1
        /* WORKSPACE */
        , false)
      }, false);

      if (shouldRestartFind) {
        _this._start({
          forceRevealReplace: false,
          seedSearchStringFromSelection: false && _this._editor.getOption(29
          /* find */
          ).seedSearchStringFromSelection,
          seedSearchStringFromGlobalClipboard: false,
          shouldFocus: 0
          /* NoFocusChange */
          ,
          shouldAnimate: false,
          updateSearchScope: false,
          loop: _this._editor.getOption(29
          /* find */
          ).loop
        });
      }
    }));

    return _this;
  }

  _createClass(CommonFindController, [{
    key: "dispose",
    value: function dispose() {
      this.disposeModel();

      _get(_getPrototypeOf(CommonFindController.prototype), "dispose", this).call(this);
    }
  }, {
    key: "disposeModel",
    value: function disposeModel() {
      if (this._model) {
        this._model.dispose();

        this._model = null;
      }
    }
  }, {
    key: "_onStateChanged",
    value: function _onStateChanged(e) {
      this.saveQueryState(e);

      if (e.isRevealed) {
        if (this._state.isRevealed) {
          this._findWidgetVisible.set(true);
        } else {
          this._findWidgetVisible.reset();

          this.disposeModel();
        }
      }

      if (e.searchString) {
        this.setGlobalBufferTerm(this._state.searchString);
      }
    }
  }, {
    key: "saveQueryState",
    value: function saveQueryState(e) {
      if (e.isRegex) {
        this._storageService.store('editor.isRegex', this._state.actualIsRegex, 1
        /* WORKSPACE */
        );
      }

      if (e.wholeWord) {
        this._storageService.store('editor.wholeWord', this._state.actualWholeWord, 1
        /* WORKSPACE */
        );
      }

      if (e.matchCase) {
        this._storageService.store('editor.matchCase', this._state.actualMatchCase, 1
        /* WORKSPACE */
        );
      }

      if (e.preserveCase) {
        this._storageService.store('editor.preserveCase', this._state.actualPreserveCase, 1
        /* WORKSPACE */
        );
      }
    }
  }, {
    key: "loadQueryState",
    value: function loadQueryState() {
      this._state.change({
        matchCase: this._storageService.getBoolean('editor.matchCase', 1
        /* WORKSPACE */
        , this._state.matchCase),
        wholeWord: this._storageService.getBoolean('editor.wholeWord', 1
        /* WORKSPACE */
        , this._state.wholeWord),
        isRegex: this._storageService.getBoolean('editor.isRegex', 1
        /* WORKSPACE */
        , this._state.isRegex),
        preserveCase: this._storageService.getBoolean('editor.preserveCase', 1
        /* WORKSPACE */
        , this._state.preserveCase)
      }, false);
    }
  }, {
    key: "isFindInputFocused",
    value: function isFindInputFocused() {
      return !!CONTEXT_FIND_INPUT_FOCUSED.getValue(this._contextKeyService);
    }
  }, {
    key: "getState",
    value: function getState() {
      return this._state;
    }
  }, {
    key: "closeFindWidget",
    value: function closeFindWidget() {
      this._state.change({
        isRevealed: false,
        searchScope: null
      }, false);

      this._editor.focus();
    }
  }, {
    key: "toggleCaseSensitive",
    value: function toggleCaseSensitive() {
      this._state.change({
        matchCase: !this._state.matchCase
      }, false);

      if (!this._state.isRevealed) {
        this.highlightFindOptions();
      }
    }
  }, {
    key: "toggleWholeWords",
    value: function toggleWholeWords() {
      this._state.change({
        wholeWord: !this._state.wholeWord
      }, false);

      if (!this._state.isRevealed) {
        this.highlightFindOptions();
      }
    }
  }, {
    key: "toggleRegex",
    value: function toggleRegex() {
      this._state.change({
        isRegex: !this._state.isRegex
      }, false);

      if (!this._state.isRevealed) {
        this.highlightFindOptions();
      }
    }
  }, {
    key: "toggleSearchScope",
    value: function toggleSearchScope() {
      var _this2 = this;

      if (this._state.searchScope) {
        this._state.change({
          searchScope: null
        }, true);
      } else {
        if (this._editor.hasModel()) {
          var selections = this._editor.getSelections();

          selections.map(function (selection) {
            if (selection.endColumn === 1 && selection.endLineNumber > selection.startLineNumber) {
              selection = selection.setEndPosition(selection.endLineNumber - 1, _this2._editor.getModel().getLineMaxColumn(selection.endLineNumber - 1));
            }

            if (!selection.isEmpty()) {
              return selection;
            }

            return null;
          }).filter(function (element) {
            return !!element;
          });

          if (selections.length) {
            this._state.change({
              searchScope: selections
            }, true);
          }
        }
      }
    }
  }, {
    key: "setSearchString",
    value: function setSearchString(searchString) {
      if (this._state.isRegex) {
        searchString = strings.escapeRegExpCharacters(searchString);
      }

      this._state.change({
        searchString: searchString
      }, false);
    }
  }, {
    key: "highlightFindOptions",
    value: function highlightFindOptions() {// overwritten in subclass
    }
  }, {
    key: "_start",
    value: function _start(opts) {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        var stateChanges, selectionSearchString, _selectionSearchString, currentSelections;

        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                this.disposeModel();

                if (this._editor.hasModel()) {
                  _context.next = 3;
                  break;
                }

                return _context.abrupt("return");

              case 3:
                stateChanges = {
                  isRevealed: true
                };

                if (opts.seedSearchStringFromSelection) {
                  selectionSearchString = getSelectionSearchString(this._editor);

                  if (selectionSearchString) {
                    if (this._state.isRegex) {
                      stateChanges.searchString = strings.escapeRegExpCharacters(selectionSearchString);
                    } else {
                      stateChanges.searchString = selectionSearchString;
                    }
                  }
                }

                if (!(!stateChanges.searchString && opts.seedSearchStringFromGlobalClipboard)) {
                  _context.next = 12;
                  break;
                }

                _context.next = 8;
                return this.getGlobalBufferTerm();

              case 8:
                _selectionSearchString = _context.sent;

                if (this._editor.hasModel()) {
                  _context.next = 11;
                  break;
                }

                return _context.abrupt("return");

              case 11:
                if (_selectionSearchString) {
                  stateChanges.searchString = _selectionSearchString;
                }

              case 12:
                // Overwrite isReplaceRevealed
                if (opts.forceRevealReplace) {
                  stateChanges.isReplaceRevealed = true;
                } else if (!this._findWidgetVisible.get()) {
                  stateChanges.isReplaceRevealed = false;
                }

                if (opts.updateSearchScope) {
                  currentSelections = this._editor.getSelections();

                  if (currentSelections.some(function (selection) {
                    return !selection.isEmpty();
                  })) {
                    stateChanges.searchScope = currentSelections;
                  }
                }

                stateChanges.loop = opts.loop;

                this._state.change(stateChanges, false);

                if (!this._model) {
                  this._model = new FindModelBoundToEditorModel(this._editor, this._state);
                }

              case 17:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));
    }
  }, {
    key: "start",
    value: function start(opts) {
      return this._start(opts);
    }
  }, {
    key: "moveToNextMatch",
    value: function moveToNextMatch() {
      if (this._model) {
        this._model.moveToNextMatch();

        return true;
      }

      return false;
    }
  }, {
    key: "moveToPrevMatch",
    value: function moveToPrevMatch() {
      if (this._model) {
        this._model.moveToPrevMatch();

        return true;
      }

      return false;
    }
  }, {
    key: "replace",
    value: function replace() {
      if (this._model) {
        this._model.replace();

        return true;
      }

      return false;
    }
  }, {
    key: "replaceAll",
    value: function replaceAll() {
      if (this._model) {
        this._model.replaceAll();

        return true;
      }

      return false;
    }
  }, {
    key: "selectAllMatches",
    value: function selectAllMatches() {
      if (this._model) {
        this._model.selectAllMatches();

        this._editor.focus();

        return true;
      }

      return false;
    }
  }, {
    key: "getGlobalBufferTerm",
    value: function getGlobalBufferTerm() {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                if (!(this._editor.getOption(29
                /* find */
                ).globalFindClipboard && this._editor.hasModel() && !this._editor.getModel().isTooLargeForSyncing())) {
                  _context2.next = 2;
                  break;
                }

                return _context2.abrupt("return", this._clipboardService.readFindText());

              case 2:
                return _context2.abrupt("return", '');

              case 3:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));
    }
  }, {
    key: "setGlobalBufferTerm",
    value: function setGlobalBufferTerm(text) {
      if (this._editor.getOption(29
      /* find */
      ).globalFindClipboard && this._editor.hasModel() && !this._editor.getModel().isTooLargeForSyncing()) {
        // intentionally not awaited
        this._clipboardService.writeFindText(text);
      }
    }
  }], [{
    key: "get",
    value: function get(editor) {
      return editor.getContribution(CommonFindController.ID);
    }
  }]);

  return CommonFindController;
}(Disposable);

CommonFindController.ID = 'editor.contrib.findController';
CommonFindController = __decorate([__param(1, IContextKeyService), __param(2, IStorageService), __param(3, IClipboardService)], CommonFindController);
export { CommonFindController };

var FindController = /*#__PURE__*/function (_CommonFindController) {
  _inherits(FindController, _CommonFindController);

  var _super3 = _createSuper(FindController);

  function FindController(editor, _contextViewService, _contextKeyService, _keybindingService, _themeService, _notificationService, _storageService, _storageKeysSyncRegistryService, clipboardService) {
    var _this3;

    _classCallCheck(this, FindController);

    _this3 = _super3.call(this, editor, _contextKeyService, _storageService, clipboardService);
    _this3._contextViewService = _contextViewService;
    _this3._keybindingService = _keybindingService;
    _this3._themeService = _themeService;
    _this3._notificationService = _notificationService;
    _this3._storageKeysSyncRegistryService = _storageKeysSyncRegistryService;
    _this3._widget = null;
    _this3._findOptionsWidget = null;
    return _this3;
  }

  _createClass(FindController, [{
    key: "_start",
    value: function _start(opts) {
      var _this4 = this;

      var _super = Object.create(null, {
        _start: {
          get: function get() {
            return _get(_getPrototypeOf(FindController.prototype), "_start", _this4);
          }
        }
      });

      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee3() {
        var selection, updateSearchScope, isSelectionMultipleLine;
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                if (!this._widget) {
                  this._createFindWidget();
                }

                selection = this._editor.getSelection();
                updateSearchScope = false;
                _context3.t0 = this._editor.getOption(29
                /* find */
                ).autoFindInSelection;
                _context3.next = _context3.t0 === 'always' ? 6 : _context3.t0 === 'never' ? 8 : _context3.t0 === 'multiline' ? 10 : 13;
                break;

              case 6:
                updateSearchScope = true;
                return _context3.abrupt("break", 14);

              case 8:
                updateSearchScope = false;
                return _context3.abrupt("break", 14);

              case 10:
                isSelectionMultipleLine = !!selection && selection.startLineNumber !== selection.endLineNumber;
                updateSearchScope = isSelectionMultipleLine;
                return _context3.abrupt("break", 14);

              case 13:
                return _context3.abrupt("break", 14);

              case 14:
                opts.updateSearchScope = updateSearchScope;
                _context3.next = 17;
                return _super._start.call(this, opts);

              case 17:
                if (this._widget) {
                  if (opts.shouldFocus === 2
                  /* FocusReplaceInput */
                  ) {
                    this._widget.focusReplaceInput();
                  } else if (opts.shouldFocus === 1
                  /* FocusFindInput */
                  ) {
                    this._widget.focusFindInput();
                  }
                }

              case 18:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));
    }
  }, {
    key: "highlightFindOptions",
    value: function highlightFindOptions() {
      if (!this._widget) {
        this._createFindWidget();
      }

      if (this._state.isRevealed) {
        this._widget.highlightFindOptions();
      } else {
        this._findOptionsWidget.highlightFindOptions();
      }
    }
  }, {
    key: "_createFindWidget",
    value: function _createFindWidget() {
      this._widget = this._register(new FindWidget(this._editor, this, this._state, this._contextViewService, this._keybindingService, this._contextKeyService, this._themeService, this._storageService, this._notificationService, this._storageKeysSyncRegistryService));
      this._findOptionsWidget = this._register(new FindOptionsWidget(this._editor, this._state, this._keybindingService, this._themeService));
    }
  }]);

  return FindController;
}(CommonFindController);

FindController = __decorate([__param(1, IContextViewService), __param(2, IContextKeyService), __param(3, IKeybindingService), __param(4, IThemeService), __param(5, INotificationService), __param(6, IStorageService), __param(7, IStorageKeysSyncRegistryService), __param(8, IClipboardService)], FindController);
export { FindController };
export var StartFindAction = /*#__PURE__*/function (_MultiEditorAction) {
  _inherits(StartFindAction, _MultiEditorAction);

  var _super4 = _createSuper(StartFindAction);

  function StartFindAction() {
    _classCallCheck(this, StartFindAction);

    return _super4.call(this, {
      id: FIND_IDS.StartFindAction,
      label: nls.localize('startFindAction', "Find"),
      alias: 'Find',
      precondition: undefined,
      kbOpts: {
        kbExpr: null,
        primary: 2048
        /* CtrlCmd */
        | 36
        /* KEY_F */
        ,
        weight: 100
        /* EditorContrib */

      },
      menuOpts: {
        menuId: MenuId.MenubarEditMenu,
        group: '3_find',
        title: nls.localize({
          key: 'miFind',
          comment: ['&& denotes a mnemonic']
        }, "&&Find"),
        order: 1
      }
    });
  }

  _createClass(StartFindAction, [{
    key: "run",
    value: function run(accessor, editor) {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee4() {
        var controller;
        return _regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                controller = CommonFindController.get(editor);

                if (!controller) {
                  _context4.next = 4;
                  break;
                }

                _context4.next = 4;
                return controller.start({
                  forceRevealReplace: false,
                  seedSearchStringFromSelection: editor.getOption(29
                  /* find */
                  ).seedSearchStringFromSelection,
                  seedSearchStringFromGlobalClipboard: editor.getOption(29
                  /* find */
                  ).globalFindClipboard,
                  shouldFocus: 1
                  /* FocusFindInput */
                  ,
                  shouldAnimate: true,
                  updateSearchScope: false,
                  loop: editor.getOption(29
                  /* find */
                  ).loop
                });

              case 4:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4);
      }));
    }
  }]);

  return StartFindAction;
}(MultiEditorAction);
export var StartFindWithSelectionAction = /*#__PURE__*/function (_EditorAction) {
  _inherits(StartFindWithSelectionAction, _EditorAction);

  var _super5 = _createSuper(StartFindWithSelectionAction);

  function StartFindWithSelectionAction() {
    _classCallCheck(this, StartFindWithSelectionAction);

    return _super5.call(this, {
      id: FIND_IDS.StartFindWithSelection,
      label: nls.localize('startFindWithSelectionAction', "Find With Selection"),
      alias: 'Find With Selection',
      precondition: undefined,
      kbOpts: {
        kbExpr: null,
        primary: 0,
        mac: {
          primary: 2048
          /* CtrlCmd */
          | 35
          /* KEY_E */

        },
        weight: 100
        /* EditorContrib */

      }
    });
  }

  _createClass(StartFindWithSelectionAction, [{
    key: "run",
    value: function run(accessor, editor) {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee5() {
        var controller;
        return _regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                controller = CommonFindController.get(editor);

                if (!controller) {
                  _context5.next = 5;
                  break;
                }

                _context5.next = 4;
                return controller.start({
                  forceRevealReplace: false,
                  seedSearchStringFromSelection: true,
                  seedSearchStringFromGlobalClipboard: false,
                  shouldFocus: 0
                  /* NoFocusChange */
                  ,
                  shouldAnimate: true,
                  updateSearchScope: false,
                  loop: editor.getOption(29
                  /* find */
                  ).loop
                });

              case 4:
                controller.setGlobalBufferTerm(controller.getState().searchString);

              case 5:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5);
      }));
    }
  }]);

  return StartFindWithSelectionAction;
}(EditorAction);
export var MatchFindAction = /*#__PURE__*/function (_EditorAction2) {
  _inherits(MatchFindAction, _EditorAction2);

  var _super6 = _createSuper(MatchFindAction);

  function MatchFindAction() {
    _classCallCheck(this, MatchFindAction);

    return _super6.apply(this, arguments);
  }

  _createClass(MatchFindAction, [{
    key: "run",
    value: function run(accessor, editor) {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee6() {
        var controller;
        return _regeneratorRuntime.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                controller = CommonFindController.get(editor);

                if (!(controller && !this._run(controller))) {
                  _context6.next = 5;
                  break;
                }

                _context6.next = 4;
                return controller.start({
                  forceRevealReplace: false,
                  seedSearchStringFromSelection: controller.getState().searchString.length === 0 && editor.getOption(29
                  /* find */
                  ).seedSearchStringFromSelection,
                  seedSearchStringFromGlobalClipboard: true,
                  shouldFocus: 0
                  /* NoFocusChange */
                  ,
                  shouldAnimate: true,
                  updateSearchScope: false,
                  loop: editor.getOption(29
                  /* find */
                  ).loop
                });

              case 4:
                this._run(controller);

              case 5:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6, this);
      }));
    }
  }]);

  return MatchFindAction;
}(EditorAction);
export var NextMatchFindAction = /*#__PURE__*/function (_MatchFindAction) {
  _inherits(NextMatchFindAction, _MatchFindAction);

  var _super7 = _createSuper(NextMatchFindAction);

  function NextMatchFindAction() {
    _classCallCheck(this, NextMatchFindAction);

    return _super7.call(this, {
      id: FIND_IDS.NextMatchFindAction,
      label: nls.localize('findNextMatchAction', "Find Next"),
      alias: 'Find Next',
      precondition: undefined,
      kbOpts: {
        kbExpr: EditorContextKeys.focus,
        primary: 61
        /* F3 */
        ,
        mac: {
          primary: 2048
          /* CtrlCmd */
          | 37
          /* KEY_G */
          ,
          secondary: [61
          /* F3 */
          ]
        },
        weight: 100
        /* EditorContrib */

      }
    });
  }

  _createClass(NextMatchFindAction, [{
    key: "_run",
    value: function _run(controller) {
      return controller.moveToNextMatch();
    }
  }]);

  return NextMatchFindAction;
}(MatchFindAction);
export var NextMatchFindAction2 = /*#__PURE__*/function (_MatchFindAction2) {
  _inherits(NextMatchFindAction2, _MatchFindAction2);

  var _super8 = _createSuper(NextMatchFindAction2);

  function NextMatchFindAction2() {
    _classCallCheck(this, NextMatchFindAction2);

    return _super8.call(this, {
      id: FIND_IDS.NextMatchFindAction,
      label: nls.localize('findNextMatchAction', "Find Next"),
      alias: 'Find Next',
      precondition: undefined,
      kbOpts: {
        kbExpr: ContextKeyExpr.and(EditorContextKeys.focus, CONTEXT_FIND_INPUT_FOCUSED),
        primary: 3
        /* Enter */
        ,
        weight: 100
        /* EditorContrib */

      }
    });
  }

  _createClass(NextMatchFindAction2, [{
    key: "_run",
    value: function _run(controller) {
      return controller.moveToNextMatch();
    }
  }]);

  return NextMatchFindAction2;
}(MatchFindAction);
export var PreviousMatchFindAction = /*#__PURE__*/function (_MatchFindAction3) {
  _inherits(PreviousMatchFindAction, _MatchFindAction3);

  var _super9 = _createSuper(PreviousMatchFindAction);

  function PreviousMatchFindAction() {
    _classCallCheck(this, PreviousMatchFindAction);

    return _super9.call(this, {
      id: FIND_IDS.PreviousMatchFindAction,
      label: nls.localize('findPreviousMatchAction', "Find Previous"),
      alias: 'Find Previous',
      precondition: undefined,
      kbOpts: {
        kbExpr: EditorContextKeys.focus,
        primary: 1024
        /* Shift */
        | 61
        /* F3 */
        ,
        mac: {
          primary: 2048
          /* CtrlCmd */
          | 1024
          /* Shift */
          | 37
          /* KEY_G */
          ,
          secondary: [1024
          /* Shift */
          | 61
          /* F3 */
          ]
        },
        weight: 100
        /* EditorContrib */

      }
    });
  }

  _createClass(PreviousMatchFindAction, [{
    key: "_run",
    value: function _run(controller) {
      return controller.moveToPrevMatch();
    }
  }]);

  return PreviousMatchFindAction;
}(MatchFindAction);
export var PreviousMatchFindAction2 = /*#__PURE__*/function (_MatchFindAction4) {
  _inherits(PreviousMatchFindAction2, _MatchFindAction4);

  var _super10 = _createSuper(PreviousMatchFindAction2);

  function PreviousMatchFindAction2() {
    _classCallCheck(this, PreviousMatchFindAction2);

    return _super10.call(this, {
      id: FIND_IDS.PreviousMatchFindAction,
      label: nls.localize('findPreviousMatchAction', "Find Previous"),
      alias: 'Find Previous',
      precondition: undefined,
      kbOpts: {
        kbExpr: ContextKeyExpr.and(EditorContextKeys.focus, CONTEXT_FIND_INPUT_FOCUSED),
        primary: 1024
        /* Shift */
        | 3
        /* Enter */
        ,
        weight: 100
        /* EditorContrib */

      }
    });
  }

  _createClass(PreviousMatchFindAction2, [{
    key: "_run",
    value: function _run(controller) {
      return controller.moveToPrevMatch();
    }
  }]);

  return PreviousMatchFindAction2;
}(MatchFindAction);
export var SelectionMatchFindAction = /*#__PURE__*/function (_EditorAction3) {
  _inherits(SelectionMatchFindAction, _EditorAction3);

  var _super11 = _createSuper(SelectionMatchFindAction);

  function SelectionMatchFindAction() {
    _classCallCheck(this, SelectionMatchFindAction);

    return _super11.apply(this, arguments);
  }

  _createClass(SelectionMatchFindAction, [{
    key: "run",
    value: function run(accessor, editor) {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee7() {
        var controller, selectionSearchString;
        return _regeneratorRuntime.wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                controller = CommonFindController.get(editor);

                if (controller) {
                  _context7.next = 3;
                  break;
                }

                return _context7.abrupt("return");

              case 3:
                selectionSearchString = getSelectionSearchString(editor);

                if (selectionSearchString) {
                  controller.setSearchString(selectionSearchString);
                }

                if (this._run(controller)) {
                  _context7.next = 9;
                  break;
                }

                _context7.next = 8;
                return controller.start({
                  forceRevealReplace: false,
                  seedSearchStringFromSelection: editor.getOption(29
                  /* find */
                  ).seedSearchStringFromSelection,
                  seedSearchStringFromGlobalClipboard: false,
                  shouldFocus: 0
                  /* NoFocusChange */
                  ,
                  shouldAnimate: true,
                  updateSearchScope: false,
                  loop: editor.getOption(29
                  /* find */
                  ).loop
                });

              case 8:
                this._run(controller);

              case 9:
              case "end":
                return _context7.stop();
            }
          }
        }, _callee7, this);
      }));
    }
  }]);

  return SelectionMatchFindAction;
}(EditorAction);
export var NextSelectionMatchFindAction = /*#__PURE__*/function (_SelectionMatchFindAc) {
  _inherits(NextSelectionMatchFindAction, _SelectionMatchFindAc);

  var _super12 = _createSuper(NextSelectionMatchFindAction);

  function NextSelectionMatchFindAction() {
    _classCallCheck(this, NextSelectionMatchFindAction);

    return _super12.call(this, {
      id: FIND_IDS.NextSelectionMatchFindAction,
      label: nls.localize('nextSelectionMatchFindAction', "Find Next Selection"),
      alias: 'Find Next Selection',
      precondition: undefined,
      kbOpts: {
        kbExpr: EditorContextKeys.focus,
        primary: 2048
        /* CtrlCmd */
        | 61
        /* F3 */
        ,
        weight: 100
        /* EditorContrib */

      }
    });
  }

  _createClass(NextSelectionMatchFindAction, [{
    key: "_run",
    value: function _run(controller) {
      return controller.moveToNextMatch();
    }
  }]);

  return NextSelectionMatchFindAction;
}(SelectionMatchFindAction);
export var PreviousSelectionMatchFindAction = /*#__PURE__*/function (_SelectionMatchFindAc2) {
  _inherits(PreviousSelectionMatchFindAction, _SelectionMatchFindAc2);

  var _super13 = _createSuper(PreviousSelectionMatchFindAction);

  function PreviousSelectionMatchFindAction() {
    _classCallCheck(this, PreviousSelectionMatchFindAction);

    return _super13.call(this, {
      id: FIND_IDS.PreviousSelectionMatchFindAction,
      label: nls.localize('previousSelectionMatchFindAction', "Find Previous Selection"),
      alias: 'Find Previous Selection',
      precondition: undefined,
      kbOpts: {
        kbExpr: EditorContextKeys.focus,
        primary: 2048
        /* CtrlCmd */
        | 1024
        /* Shift */
        | 61
        /* F3 */
        ,
        weight: 100
        /* EditorContrib */

      }
    });
  }

  _createClass(PreviousSelectionMatchFindAction, [{
    key: "_run",
    value: function _run(controller) {
      return controller.moveToPrevMatch();
    }
  }]);

  return PreviousSelectionMatchFindAction;
}(SelectionMatchFindAction);
export var StartFindReplaceAction = /*#__PURE__*/function (_MultiEditorAction2) {
  _inherits(StartFindReplaceAction, _MultiEditorAction2);

  var _super14 = _createSuper(StartFindReplaceAction);

  function StartFindReplaceAction() {
    _classCallCheck(this, StartFindReplaceAction);

    return _super14.call(this, {
      id: FIND_IDS.StartFindReplaceAction,
      label: nls.localize('startReplace', "Replace"),
      alias: 'Replace',
      precondition: undefined,
      kbOpts: {
        kbExpr: null,
        primary: 2048
        /* CtrlCmd */
        | 38
        /* KEY_H */
        ,
        mac: {
          primary: 2048
          /* CtrlCmd */
          | 512
          /* Alt */
          | 36
          /* KEY_F */

        },
        weight: 100
        /* EditorContrib */

      },
      menuOpts: {
        menuId: MenuId.MenubarEditMenu,
        group: '3_find',
        title: nls.localize({
          key: 'miReplace',
          comment: ['&& denotes a mnemonic']
        }, "&&Replace"),
        order: 2
      }
    });
  }

  _createClass(StartFindReplaceAction, [{
    key: "run",
    value: function run(accessor, editor) {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee8() {
        var controller, currentSelection, findInputFocused, seedSearchStringFromSelection, shouldFocus;
        return _regeneratorRuntime.wrap(function _callee8$(_context8) {
          while (1) {
            switch (_context8.prev = _context8.next) {
              case 0:
                if (!(!editor.hasModel() || editor.getOption(72
                /* readOnly */
                ))) {
                  _context8.next = 2;
                  break;
                }

                return _context8.abrupt("return");

              case 2:
                controller = CommonFindController.get(editor);
                currentSelection = editor.getSelection();
                findInputFocused = controller.isFindInputFocused(); // we only seed search string from selection when the current selection is single line and not empty,
                // + the find input is not focused

                seedSearchStringFromSelection = !currentSelection.isEmpty() && currentSelection.startLineNumber === currentSelection.endLineNumber && editor.getOption(29
                /* find */
                ).seedSearchStringFromSelection && !findInputFocused;
                /*
                 * if the existing search string in find widget is empty and we don't seed search string from selection, it means the Find Input is still empty, so we should focus the Find Input instead of Replace Input.
                      * findInputFocused true -> seedSearchStringFromSelection false, FocusReplaceInput
                 * findInputFocused false, seedSearchStringFromSelection true FocusReplaceInput
                 * findInputFocused false seedSearchStringFromSelection false FocusFindInput
                 */

                shouldFocus = findInputFocused || seedSearchStringFromSelection ? 2
                /* FocusReplaceInput */
                : 1;

                if (!controller) {
                  _context8.next = 10;
                  break;
                }

                _context8.next = 10;
                return controller.start({
                  forceRevealReplace: true,
                  seedSearchStringFromSelection: seedSearchStringFromSelection,
                  seedSearchStringFromGlobalClipboard: editor.getOption(29
                  /* find */
                  ).seedSearchStringFromSelection,
                  shouldFocus: shouldFocus,
                  shouldAnimate: true,
                  updateSearchScope: false,
                  loop: editor.getOption(29
                  /* find */
                  ).loop
                });

              case 10:
              case "end":
                return _context8.stop();
            }
          }
        }, _callee8);
      }));
    }
  }]);

  return StartFindReplaceAction;
}(MultiEditorAction);
registerEditorContribution(CommonFindController.ID, FindController);
export var EditorStartFindAction = new StartFindAction();
registerMultiEditorAction(EditorStartFindAction);
registerEditorAction(StartFindWithSelectionAction);
registerEditorAction(NextMatchFindAction);
registerEditorAction(NextMatchFindAction2);
registerEditorAction(PreviousMatchFindAction);
registerEditorAction(PreviousMatchFindAction2);
registerEditorAction(NextSelectionMatchFindAction);
registerEditorAction(PreviousSelectionMatchFindAction);
export var EditorStartFindReplaceAction = new StartFindReplaceAction();
registerMultiEditorAction(EditorStartFindReplaceAction);
var FindCommand = EditorCommand.bindToContribution(CommonFindController.get);
registerEditorCommand(new FindCommand({
  id: FIND_IDS.CloseFindWidgetCommand,
  precondition: CONTEXT_FIND_WIDGET_VISIBLE,
  handler: function handler(x) {
    return x.closeFindWidget();
  },
  kbOpts: {
    weight: 100
    /* EditorContrib */
    + 5,
    kbExpr: EditorContextKeys.focus,
    primary: 9
    /* Escape */
    ,
    secondary: [1024
    /* Shift */
    | 9
    /* Escape */
    ]
  }
}));
registerEditorCommand(new FindCommand({
  id: FIND_IDS.ToggleCaseSensitiveCommand,
  precondition: undefined,
  handler: function handler(x) {
    return x.toggleCaseSensitive();
  },
  kbOpts: {
    weight: 100
    /* EditorContrib */
    + 5,
    kbExpr: EditorContextKeys.focus,
    primary: ToggleCaseSensitiveKeybinding.primary,
    mac: ToggleCaseSensitiveKeybinding.mac,
    win: ToggleCaseSensitiveKeybinding.win,
    linux: ToggleCaseSensitiveKeybinding.linux
  }
}));
registerEditorCommand(new FindCommand({
  id: FIND_IDS.ToggleWholeWordCommand,
  precondition: undefined,
  handler: function handler(x) {
    return x.toggleWholeWords();
  },
  kbOpts: {
    weight: 100
    /* EditorContrib */
    + 5,
    kbExpr: EditorContextKeys.focus,
    primary: ToggleWholeWordKeybinding.primary,
    mac: ToggleWholeWordKeybinding.mac,
    win: ToggleWholeWordKeybinding.win,
    linux: ToggleWholeWordKeybinding.linux
  }
}));
registerEditorCommand(new FindCommand({
  id: FIND_IDS.ToggleRegexCommand,
  precondition: undefined,
  handler: function handler(x) {
    return x.toggleRegex();
  },
  kbOpts: {
    weight: 100
    /* EditorContrib */
    + 5,
    kbExpr: EditorContextKeys.focus,
    primary: ToggleRegexKeybinding.primary,
    mac: ToggleRegexKeybinding.mac,
    win: ToggleRegexKeybinding.win,
    linux: ToggleRegexKeybinding.linux
  }
}));
registerEditorCommand(new FindCommand({
  id: FIND_IDS.ToggleSearchScopeCommand,
  precondition: undefined,
  handler: function handler(x) {
    return x.toggleSearchScope();
  },
  kbOpts: {
    weight: 100
    /* EditorContrib */
    + 5,
    kbExpr: EditorContextKeys.focus,
    primary: ToggleSearchScopeKeybinding.primary,
    mac: ToggleSearchScopeKeybinding.mac,
    win: ToggleSearchScopeKeybinding.win,
    linux: ToggleSearchScopeKeybinding.linux
  }
}));
registerEditorCommand(new FindCommand({
  id: FIND_IDS.ReplaceOneAction,
  precondition: CONTEXT_FIND_WIDGET_VISIBLE,
  handler: function handler(x) {
    return x.replace();
  },
  kbOpts: {
    weight: 100
    /* EditorContrib */
    + 5,
    kbExpr: EditorContextKeys.focus,
    primary: 2048
    /* CtrlCmd */
    | 1024
    /* Shift */
    | 22
    /* KEY_1 */

  }
}));
registerEditorCommand(new FindCommand({
  id: FIND_IDS.ReplaceOneAction,
  precondition: CONTEXT_FIND_WIDGET_VISIBLE,
  handler: function handler(x) {
    return x.replace();
  },
  kbOpts: {
    weight: 100
    /* EditorContrib */
    + 5,
    kbExpr: ContextKeyExpr.and(EditorContextKeys.focus, CONTEXT_REPLACE_INPUT_FOCUSED),
    primary: 3
    /* Enter */

  }
}));
registerEditorCommand(new FindCommand({
  id: FIND_IDS.ReplaceAllAction,
  precondition: CONTEXT_FIND_WIDGET_VISIBLE,
  handler: function handler(x) {
    return x.replaceAll();
  },
  kbOpts: {
    weight: 100
    /* EditorContrib */
    + 5,
    kbExpr: EditorContextKeys.focus,
    primary: 2048
    /* CtrlCmd */
    | 512
    /* Alt */
    | 3
    /* Enter */

  }
}));
registerEditorCommand(new FindCommand({
  id: FIND_IDS.ReplaceAllAction,
  precondition: CONTEXT_FIND_WIDGET_VISIBLE,
  handler: function handler(x) {
    return x.replaceAll();
  },
  kbOpts: {
    weight: 100
    /* EditorContrib */
    + 5,
    kbExpr: ContextKeyExpr.and(EditorContextKeys.focus, CONTEXT_REPLACE_INPUT_FOCUSED),
    primary: undefined,
    mac: {
      primary: 2048
      /* CtrlCmd */
      | 3
      /* Enter */

    }
  }
}));
registerEditorCommand(new FindCommand({
  id: FIND_IDS.SelectAllMatchesAction,
  precondition: CONTEXT_FIND_WIDGET_VISIBLE,
  handler: function handler(x) {
    return x.selectAllMatches();
  },
  kbOpts: {
    weight: 100
    /* EditorContrib */
    + 5,
    kbExpr: EditorContextKeys.focus,
    primary: 512
    /* Alt */
    | 3
    /* Enter */

  }
}));